import React, { useEffect } from 'react';
import Head from 'next/head';
import { useRouter } from 'next/router';
// import { ApolloProvider } from '@apollo/client';
// import client from '../common/Apolloconfig/index';
import { Amplify } from 'aws-amplify';
import CognitoConfig from '../common/Cognitoconfig';

// Global CSS imports - these can only be imported here
import 'semantic-ui-css/semantic.min.css';
import '../components/ViewToggle/ViewToggle.css';
import '../components/MapTabs/MapTabs.css';
import '../components/NhRankingSearchSuggestion/NhRankingSearchSuggestion.css';
import '../static/css/react-toogle.css';
import 'react-dropzone-uploader/dist/styles.css';
import 'react-rangeslider/lib/index.css'
import 'rc-slider/assets/index.css';

// Import other global styles if they exist
// Add any other global CSS imports here as needed

// Configure Amplify once for the entire app
if (typeof window !== 'undefined') {
  Amplify.configure(CognitoConfig);
}

function MyApp({ Component, pageProps }) {
  const router = useRouter();
  // useEffect(() => {
  //   Ensure Amplify is configured on client side
  //   if (typeof window !== 'undefined') {
  //     Amplify.configure(CognitoConfig);
  //   }
  // }, []);

  useEffect(() => {
    // If we are not on the home page, remove the initial loading screen immediately
    if (router.pathname !== '/') {
      requestAnimationFrame(() => {
        const loadingScreen = document.getElementById('initial-loading-screen');
        if (loadingScreen) {
          loadingScreen.classList.add('hidden');
          setTimeout(() => {
            if (loadingScreen.parentNode) {
              loadingScreen.parentNode.removeChild(loadingScreen);
            }
          }, 10);
        }
      });
    }
  }, [router.pathname]);

  return (
    <>
      <Head>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0"
        />
      </Head>
      {/* <ApolloProvider client={client}> */}
      <Component {...pageProps} />
      {/* </ApolloProvider> */}
    </>
  );
}

export default MyApp;